/**
 * Utility functions for handling dates without timezone influence
 */

/**
 * Creates a timezone-independent date by setting the time to midnight UTC
 * This ensures the date represents the same calendar day regardless of timezone
 */
export const createTimezoneIndependentDate = (year: number, month: number, day: number): Date => {
  // Create date using UTC to avoid timezone issues
  // This ensures the selected calendar date is preserved regardless of user's timezone
  return new Date(year, month, day, 12, 0, 0);
};